// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UUID = function (x) {
    return x;
};
var tsBridgeUUID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UUID")("__brandUUID"));
    }
};
var writeUUID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUUID = Data_Show.showString;
var readUUID = Simple_JSON.readString;
var ordUUID = Data_Ord.ordString;
var newtypeUUID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUUID = UUID;
var eqUUID = Data_Eq.eqString;
export {
    UUID,
    makeUUID,
    unwrap,
    newtypeUUID,
    eqUUID,
    ordUUID,
    showUUID,
    readUUID,
    writeUUID,
    tsBridgeUUID
};
//# sourceMappingURL=index.js.map
